import { MAX_RULES } from './builderState'
import { useRules } from './useRules'

/** Why a new rule is refused. One sentence, shown beside every blocked entry. */
export const RULE_CAP_REASON = `${MAX_RULES.toLocaleString('en-US')} rules is the limit. Delete one to add another.`

/** An unknown count (still loading, or failed) is not the cap. */
export function atRuleCap(count: number | undefined): boolean {
  return count !== undefined && count >= MAX_RULES
}

/**
 * Whether a NEW rule may be made — the one answer every entry point reads
 * (Rules, a suggestion's Create, M6's bulk "Create rule from these"), and
 * which `useRuleFlow.open` and `useSaveRule.save` enforce again.
 */
export function useRuleCap(): { atCap: boolean; reason: string } {
  const state = useRules()
  const count = state.status === 'success' || state.status === 'stale' ? state.data.length : undefined
  return { atCap: atRuleCap(count), reason: RULE_CAP_REASON }
}
